import React from 'react';

const CSVTable = ({ headers, data, classList }) => {
  const filteredData = data.filter(
    (row) => !['', undefined, null].includes(row)
  );

  const handleClassList = () => {
    if (!classList) {
      return 'table-container mb-6 col-md-8 col-12';
    } else {
      return classList;
    }
  };

  const handleHeaders = headers.map((header, idx) => (
    <th key={`${header}-${idx}`}>{header}</th>
  ));

  function skipUselessRow(row) {
    return row.every((val) => ['', undefined].includes(val));
  }

  let count = 0;

  const handleTable = filteredData.map((row, idx) => {
    if (skipUselessRow(row)) {
      return null;
    }

    count++;

    return (
      <tr key={`${row}-${idx}`}>
        <td style={{ width: '15%' }}>{count}</td>
        {row.map((col, idx) => (
          <td key={`${col}-${idx}`} className='col-md-2'>
            {col}
          </td>
        ))}
      </tr>
    );
  });

  return (
    <div className={handleClassList()}>
      <table className='table table-sm table-responsive table-striped'>
        <thead>
          <tr>
            <th className='text-nowrap'># out of {count}</th>
            {handleHeaders}
          </tr>
        </thead>
        <tbody>{handleTable}</tbody>
      </table>
    </div>
  );
};

export default CSVTable;
